import accordions from './accordions';
export default accordions;
